import { CustomerBillingModel, CustomerLiteModel } from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { ProjectLiteModel, ProjectModel } from 'api-hooks/projects';
import { Expose, Type } from 'class-transformer';
import { SaleStatusEnum, SaleTransactionTypeEnum } from 'common/constants/enum';
import { CommonModel } from 'common/repositories/common.model';

import { RescheduleHistoryModel } from './reschedule';

// DON'T DELETE THIS COMMENT CODE
// export enum SaleStatusEnum {
//   rescheduled = 'rescheduled', // TAB PROCESSED (PAYMENT STATUS: PENDING), COMPLETE (PAYMENT STATUS: COMPLETE)

//   // TAB PROCESSED
//   active = 'active',
//   open_ticket = 'open_ticket',
//   rescheduling = 'rescheduling',

//   // TAB NEED APPROVAL
//   pending_approval = 'pending_approval',
//   pending_reschedule_approval = 'pending_reschedule_approval',
//   pending_void_approval = 'pending_void_approval',
//   reschedule_draft = 'reschedule_draft',
//   draft = 'draft',
//   void_draft = 'void_draft',

//   // TAB REJECTED APPROVAL
//   rejected_approval = 'rejected_approval',
//   rejected_reschedule_approval = 'rejected_reschedule_approval',

//   // TAB COMPLETE
//   completed = 'completed',
//   void = 'void',
//   refund = 'refund',

//   // HIDDEN
//   processed = 'processed',
//   submitted = 'submitted',
//   waiting = 'waiting',
//   archived = 'archived',
// }

// DON'T DELETE THIS COMMENT CODE
// export enum DocumentSaleStatusEnum {
//   processed = 'processed',
//   submitted = 'submitted',
//   finished = 'finished',
//   canceled = 'canceled',
// }

export enum SalePurchaseTabEnum {
  Processed = 'processed',
  NeedApproval = 'need_approval',
  RejectedApproval = 'rejected_approval',
  Complete = 'complete',
  Submitted = 'submitted',
  Canceled = 'canceled',
  Void = 'void',
}

export enum ApprovalItemWorkflowEnum {
  sale = 'sale',
  purchase = 'purchase',
  purchase_payment = 'purchase_payment',
  document_sale = 'document_sale',
  sale_payment = 'sale_payment',
  sale_project = 'sale_project',
  project = 'project',
  cheque_note = 'cheque_note',
  refund = 'refund',
  release_sale = 'release_sale',
  release_purchase = 'release_purchase',
  approval_verdict = 'approval_verdict',
  approval_item = 'approval_item',
  transactional = 'transactional',
  receipt = 'receipt',
  payment = 'payment',
  mutation = 'mutation',
  tour = 'tour',
  tour_flight_hotel = 'tour_flight_hotel',
  expense_income = 'expense_income',
  sale_purchase_guest = 'sale_purchase_guest',
}

export enum SalePaymentStatusEnum {
  Pending = 'pending',
  Finished = 'finished',
  Refund = 'refund',
}

export class PurchaseRelatedModel {
  id: string;
  number: string;
  type?: 'sale_invoice' | 'purchase_order'; // HIDDEN

  @Type(() => Number)
  total: number;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;
}

export class RefundSalesModel {
  id: string;
  customer: string;
  number: string;
  reason: string;
  status: string;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'refund_id' })
  refundId: string;

  @Expose({ name: 'requested_at' })
  @Type(() => Date)
  requestedAt: Date;
}

export class SaleLiteModel extends CommonModel {
  status: SaleStatusEnum;
  code: string | null;
  guests: string[];
  description: string;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'payment_status' })
  paymentStatus: string;

  @Expose({ name: 'project_status' })
  projectStatus: string;

  @Expose({ name: 'booking_address' })
  @Type(() => CustomerBillingModel)
  bookingAddress: CustomerBillingModel;

  @Expose({ name: 'booking_codes' })
  bookingCodes: (string | null)[];

  @Expose({ name: 'transaction_type' })
  transactionType: SaleTransactionTypeEnum;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;

  @Expose({ name: 'document_type' })
  documentType: string | null;

  @Expose({ name: 'document_sale_status' })
  documentSaleStatus: string | null;

  @Expose({ name: 'billing_address' })
  @Type(() => CustomerBillingModel)
  billingAddress: CustomerBillingModel | null;

  @Expose({ name: 'is_completed' })
  @Type(() => Boolean)
  isCompleted: boolean;

  @Expose({ name: 'paid_amount' })
  @Type(() => Number)
  paidAmount: number;

  @Expose({ name: 'due_at' })
  @Type(() => Date)
  dueAt: Date;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => ProjectLiteModel)
  project: ProjectLiteModel | null;

  @Type(() => EmployeeLiteModel)
  admin: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  operator: EmployeeLiteModel | null;

  @Type(() => EmployeeLiteModel)
  salesman: EmployeeLiteModel | null;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class SaleModel extends CommonModel {
  status: SaleStatusEnum;
  description: string;
  code: string | null;
  number: string;
  acl?: string;

  @Expose({ name: 'due_at' })
  @Type(() => Date)
  dueAt: Date;

  @Type(() => Number)
  discount: number;

  @Expose({ name: 'other_cost' })
  @Type(() => Number)
  otherCost: number;

  @Expose({ name: 'paid_amount' })
  @Type(() => Number)
  paidAmount: number;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => EmployeeLiteModel)
  admin: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  operator: EmployeeLiteModel | null;

  @Type(() => EmployeeLiteModel)
  salesman: EmployeeLiteModel | null;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'customer_billing_address' })
  @Type(() => CustomerBillingModel)
  customerBillingAddress: CustomerBillingModel | null;

  @Expose({ name: 'waiting_id' })
  waitingId: string | null;

  @Type(() => PurchaseRelatedModel)
  purchases: PurchaseRelatedModel[];

  @Expose({ name: 'transaction_type' })
  transactionType: SaleTransactionTypeEnum;

  @Type(() => ProjectModel)
  project?: ProjectModel | null;

  @Expose({ name: 'is_completed' })
  @Type(() => Boolean)
  isCompleted: boolean;

  @Expose({ name: 'sale_payment_status' })
  salePaymentStatus?: SalePaymentStatusEnum;

  @Expose({ name: 'last_reissue_date' })
  @Type(() => Date)
  lastReissueDate: Date | null;

  @Expose({ name: 'last_travelling_date' })
  @Type(() => Date)
  lastTravellingDate: Date | null;

  @Expose({ name: 'release_sales' })
  @Type(() => RefundSalesModel)
  releaseSales: RefundSalesModel[];

  @Expose({ name: 'reschedule_histories' })
  @Type(() => RescheduleHistoryModel)
  rescheduleHistories: RescheduleHistoryModel[];

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;

  @Expose({ name: 'children_sales' })
  @Type(() => SaleLiteModel)
  childrenSales?: SaleLiteModel[];

  @Expose({ name: 'parent_sale' })
  @Type(() => SaleLiteModel)
  parentSale?: SaleLiteModel;
}

export class CommonMutationInput {
  refId?: string;
  parentRefId?: string;
  transactionAt: Date;
  needApproval: boolean;
  code: string;
  description: string;
  adminId: string;
  operatorId: string;
  salesmanId: string;
  customerId: string;
  customerBillingId: string;
  discount: number;
  otherCost: number;
  total: number;
}
